import React, { useState, useEffect, useCallback } from 'react';
// P0 FIX: BUILD MARKER for deployment verification
console.info('[ConnectStep] 🏗️ BUILD: 20260309_p0_x_state_persistence_FIX_V2');
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { 
  Link2, 
  Loader2, 
  CheckCircle, 
  ArrowRight,
  Mail,
  Globe,
  AlertCircle,
  Settings,
  Bot,
  ChevronDown,
  ExternalLink,
  X as XIcon,
  Send,
  Trash2,
  Plus,
  RefreshCw,
  Wrench,
  ShieldCheck,
  ShieldX,
  Key,
  Sparkles,
  HelpCircle
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { apiClient, resolveProjectId, resolveProjectIdAsync, persistProjectId, isInvalidProjectId } from '@/lib/api';
import { toSafeError, logSafeError } from '@/lib/errorHandlers';
import { toast } from 'sonner';
import GuidedProjectLayout, { useProjectSteps } from '@/components/ios26/GuidedProjectLayout';
import { GlassCard, PillButton, StatusChip, SectionHeader } from '@/components/ios26/IOSComponents';
import XOAuth1FallbackModal from '@/components/XOAuth1FallbackModal';
// P0: SocialSetupExpertDrawer is now managed centrally by GuidedProjectLayout
import '@/styles/ios26-design-system.css';
// iter 241 Lot 4 — engine-aware overlays.
import EngineSelector from '@/components/EngineSelector';
import EnginePlatformsPanel from '@/components/EnginePlatformsPanel';


// P0 TRUTHFUL: X connection states
const X_STATUS = {
  A_REPARER: 'A_REPARER',              // Legacy user_only exists, needs claim
  NON_CONNECTE: 'NON_CONNECTE',        // No tokens at all
  CONNECTE_NON_VERIFIE: 'CONNECTE_NON_VERIFIE',  // Tokens exist, not verified
  CONNECTE_VERIFIE: 'CONNECTE_VERIFIE',// Token verified valid
  EN_COURS: 'EN_COURS'                 // Operation in progress
};

/**
 * Platform Logos as SVG components for consistent styling
 */
const InstagramLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const FacebookLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const XLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const LinkedInLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const BrevoLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M3.5 5.5A2.5 2.5 0 016 3h12a2.5 2.5 0 012.5 2.5v1.1L12 11.4 3.5 6.6V5.5zM3.5 8.4v10.1A2.5 2.5 0 006 21h12a2.5 2.5 0 002.5-2.5V8.4l-8 4.5a1 1 0 01-1 0l-8-4.5z"/>
  </svg>
);

const TelegramLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const WhatsAppLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const PinterestLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/>
  </svg>
);

import { 
  PLATFORMS_CONFIG, 
  SETUP_MODES, 
  DIFFICULTY_LEVELS,
  getPlatformsSortedByDifficulty,
  getPlatformsByCategory,
  isManualPlatform,
  getDifficultyColor,
  getDifficultyLabel
} from '@/lib/platformConstants';

/**
 * Platform Logos mapping
 */
const PlatformLogos = {
  instagram: InstagramLogo,
  facebook: FacebookLogo,
  x: XLogo,
  x_twitter: XLogo,  // P0 FIX: Add x_twitter mapping to XLogo
  linkedin: LinkedInLogo,
  telegram: TelegramLogo,
  pinterest: PinterestLogo,  // Pinterest integration
  whatsapp: WhatsAppLogo,
  blog: Globe,
  brevo: BrevoLogo
};

/**
 * Difficulty Badge Component - Visual indicator for setup complexity
 */
const DifficultyBadge = ({ difficulty, showLabel = false }) => {
  const maxDots = 6;
  const color = getDifficultyColor(difficulty);
  const label = getDifficultyLabel(difficulty);
  
  return (
    <div className="flex items-center gap-2" title={`Difficulté: ${difficulty}/6 - ${label}`}>
      <div className="flex items-center gap-0.5">
        {[...Array(maxDots)].map((_, i) => (
          <span
            key={i}
            className="w-2 h-2 rounded-full transition-all"
            style={{
              backgroundColor: i < difficulty ? color : 'hsl(var(--color-border))',
              opacity: i < difficulty ? 1 : 0.3
            }}
          />
        ))}
      </div>
      {showLabel && (
        <span className="text-xs font-medium" style={{ color }}>
          {label}
        </span>
      )}
    </div>
  );
};

/**
 * Difficulty Legend Component - Explains the rating system
 */
const DifficultyLegend = () => (
  <div 
    className="p-4 rounded-xl mb-6"
    style={{ 
      backgroundColor: 'hsl(var(--color-surface-2))',
      border: '1px solid hsl(var(--color-border-subtle))'
    }}
    data-testid="difficulty-legend"
  >
    <h4 className="text-sm font-semibold text-semantic mb-3 flex items-center gap-2">
      <span className="w-5 h-5 rounded flex items-center justify-center text-xs" 
        style={{ backgroundColor: 'hsl(var(--color-info-bg))' }}>
        ?
      </span>
      Niveau de mise en place
    </h4>
    <div className="flex flex-wrap gap-4 text-xs">
      <div className="flex items-center gap-2">
        <DifficultyBadge difficulty={1} />
        <span className="text-semantic-muted">Très simple</span>
      </div>
      <span className="text-semantic-muted">→</span>
      <div className="flex items-center gap-2">
        <DifficultyBadge difficulty={6} />
        <span className="text-semantic-muted">Avancé</span>
      </div>
    </div>
    <p className="text-xs text-semantic-muted mt-3">
      Certains canaux nécessitent des permissions, une app développeur, ou une page pro.
    </p>
  </div>
);

/**
 * Platform Configuration with difficulty metadata - SORTED BY DIFFICULTY
 * Main platforms for display (excludes blog and linkedin)
 * P0 FIX: Use x_twitter to match backend channels_config.x_twitter
 */
const MAIN_PLATFORM_IDS = ['whatsapp', 'telegram', 'brevo', 'pinterest', 'x_twitter', 'facebook', 'instagram'];

const PLATFORMS = MAIN_PLATFORM_IDS.map(id => {
  const config = PLATFORMS_CONFIG[id];
  if (!config) {
    console.error(`[ConnectStep] Missing config for platform: ${id}`);
    return null;
  }
  return {
    id,
    name: config.name,
    Logo: PlatformLogos[id] || PlatformLogos['x_twitter'], // Fallback for x_twitter
    gradient: config.gradient,
    bgColor: `bg-[${config.color}]`,
    description: config.description,
    // Difficulty data
    setupDifficulty: config.setupDifficulty,
    setupMode: config.setupMode,
    difficultyLabel: config.difficultyLabel,
    difficultyHint: config.difficultyHint,
    shortHint: config.shortHint,
    manualOnly: config.setupMode === SETUP_MODES.MANUAL
  };
}).filter(Boolean); // P0 FIX: Remove null entries

/**
 * Step 2: Connecter mes comptes
 * =============================
 * USES SEMANTIC TOKENS for dark mode compatibility
 * Platforms sorted by difficulty (easiest first)
 */
function ConnectStepContent() {
  const { projectId: routeProjectId } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { completeStep, stepStatuses, setStepStatus } = useProjectSteps();
  
  // P0 FIX: Resolve projectId with fallback chain (route > localStorage > sessionStorage)
  const projectId = resolveProjectId(routeProjectId);
  
  // P0 FIX: If projectId is invalid/placeholder, show error and redirect
  useEffect(() => {
    if (isInvalidProjectId(routeProjectId) && !projectId) {
      console.error('[ConnectStep] ❌ Invalid projectId detected:', routeProjectId);
      toast.error('Projet non trouvé. Veuillez sélectionner un projet.', { duration: 5000 });
      navigate('/dashboard');
    } else if (projectId && routeProjectId !== projectId) {
      // Route has placeholder but we have a valid stored projectId - redirect to correct URL
      console.info('[ConnectStep] Redirecting to valid projectId:', projectId);
      navigate(`/projects/${projectId}/setup/connect`, { replace: true });
    }
  }, [routeProjectId, projectId, navigate]);
  
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [platformStatuses, setPlatformStatuses] = useState({});
  const [connectingPlatform, setConnectingPlatform] = useState(null);
  const [showAdvanced, setShowAdvanced] = useState({});
  const [testingPlatform, setTestingPlatform] = useState(null);
  const [disconnectingPlatform, setDisconnectingPlatform] = useState(null);
  
  // P1 NEW: Recommended channels order from analysis
  const [recommendedChannels, setRecommendedChannels] = useState([]);
  const [hasRecommendations, setHasRecommendations] = useState(false);
  
  // P0: Debug mode - only show debug UI if ?debug=1 or non-production
  const isDebugMode = searchParams.get('debug') === '1' || process.env.NODE_ENV !== 'production';
  
  // ============================================================================
  // P0 TRUTHFUL: X Connection State Management (multi-project support)
  // BUILD_MARKER: 20260308_p0_x_state_persistence_fix
  // ============================================================================
  const [xConnectionState, setXConnectionState] = useState(X_STATUS.NON_CONNECTE);
  const [xUsername, setXUsername] = useState(null);
  const [xDebugStatus, setXDebugStatus] = useState(null);
  const [lastXVerifyTime, setLastXVerifyTime] = useState(0);
  const [showClaimConfirmModal, setShowClaimConfirmModal] = useState(false);
  const [xClaimPossible, setXClaimPossible] = useState(false);
  const [xClaimReason, setXClaimReason] = useState(null);
  const X_VERIFY_DEBOUNCE_MS = 30000; // 30 seconds debounce
  
  // P0 NEW: X Test Post state
  const [xTestPosting, setXTestPosting] = useState(false);
  
  // P0 NEW: OAuth 1.0a Fallback Modal state
  const [showOAuth1FallbackModal, setShowOAuth1FallbackModal] = useState(false);
  const [hasOAuth1Fallback, setHasOAuth1Fallback] = useState(false);
  // P1 FIX: Track if user is connected via OAuth 1.0a (single source of truth)
  const [isOAuth1Connected, setIsOAuth1Connected] = useState(false);
  // P1 FIX: Media upload capability flag from backend
  const [mediaUploadCapable, setMediaUploadCapable] = useState(false);
  
  // P0 NEW: Social Setup Expert Drawer state
  const [expertDrawerOpen, setExpertDrawerOpen] = useState(false);
  const [expertDrawerPlatform, setExpertDrawerPlatform] = useState(null);
  
  // P0 SOCIAL SETUP EXPERT: Open expert drawer via global event
  // This allows the layout to manage the drawer state centrally
  const openSocialExpert = useCallback((platformId) => {
    window.dispatchEvent(new CustomEvent('ame:open-social-expert', {
      detail: { platform: platformId }
    }));
  }, []);
  
  // P0 TRUTHFUL: Determine X state from backend status
  const determineXState = useCallback((statusData) => {
    // P0 REFACTOR: Simplified for OAuth 1.0a ONLY
    // The backend now returns `connected` as true if OAuth 1.0a OR OAuth 2.0 is connected
    const {
      connected,
      has_tokens,
      is_project_scoped,
      token_valid,
      verified,  // P0 FIX: New explicit verified flag from backend
      x_username,
      claim_possible,
      claim_reason,
      oauth1,  // P0 REFACTOR: OAuth 1.0a status block
      oauth2   // P0 REFACTOR: OAuth 2.0 status block (for legacy)
    } = statusData;
    
    // Structured logging
    console.info('[ConnectStep] X status:', {
      connected,
      verified,
      has_tokens: statusData.has_tokens,
      oauth1_connected: oauth1?.connected,
      oauth1_screen_name: oauth1?.screen_name,
      has_credentials: statusData.has_credentials,
      error: statusData.error,
      build_marker: statusData.build_marker
    });
    
    // Save claim info
    setXClaimPossible(claim_possible || false);
    setXClaimReason(claim_reason);
    
    // Save username - prefer OAuth 1.0a screen_name
    const username = oauth1?.screen_name || x_username;
    if (username) setXUsername(username);
    
    // P0 FIX: connected = tokens exist, regardless of verification result
    // If tokens exist, user IS connected (even if verification failed)
    
    // Check OAuth 1.0a first (primary auth method)
    if (oauth1?.connected === true || (connected && statusData.auth_type === 'oauth1')) {
      // P0 FIX: If verified explicitly passed and false, show warning but still connected
      if (verified === false) {
        console.warn('[ConnectStep] OAuth 1.0a connected but verification failed - showing as connected with warning');
        return X_STATUS.CONNECTE_NON_VERIFIE;
      }
      return X_STATUS.CONNECTE_VERIFIE;
    }
    
    // P0 FIX: If connected=true (tokens exist), don't return NON_CONNECTE just because token_valid=false
    if (connected && is_project_scoped) {
      if (token_valid === true || verified === true) {
        return X_STATUS.CONNECTE_VERIFIE;
      }
      // P0 FIX: tokens exist but verification failed -> still "connected" but show warning
      // Don't return NON_CONNECTE here - that would lose the connection state
      return X_STATUS.CONNECTE_NON_VERIFIE;
    }
    
    // Check claim scenario
    if (claim_possible && !is_project_scoped) {
      return X_STATUS.A_REPARER;
    }
    
    return X_STATUS.NON_CONNECTE;
  }, []);

  // P0 TRUTHFUL: Full X status check (verify=false then optional verify=true)
  const checkXStatus = useCallback(async (doVerify = false) => {
    try {
      setXConnectionState(X_STATUS.EN_COURS);
      
      // Step 1: Get status without verify
      const statusResp = await apiClient.get(`/integrations/x/status?project_id=${projectId}&verify=false`);
      const statusData = statusResp.data;
      setXDebugStatus(statusData);
      
      let finalState = determineXState(statusData);
      
      // P1 FIX: Extract OAuth 1.0a status from response - SINGLE SOURCE OF TRUTH
      // The backend now returns auth_type and media_upload_capable
      const isOAuth1Auth = statusData.auth_type === 'oauth1';
      const oauth1Connected = statusData.oauth1?.connected === true;
      const hasMediaCapability = statusData.media_upload_capable === true;
      
      // P1: Set isOAuth1Connected if using OAuth 1.0a auth
      setIsOAuth1Connected(isOAuth1Auth && oauth1Connected);
      
      // P1: Set media upload capability from backend
      setMediaUploadCapable(hasMediaCapability);
      
      // P1: hasOAuth1Fallback is TRUE if connected via OAuth 1.0a OR has media capability
      // This maintains backward compatibility with existing UI logic
      if (oauth1Connected || hasMediaCapability) {
        setHasOAuth1Fallback(true);
        console.info('[ConnectStep] OAuth 1.0a: CONNECTED, media_upload_capable=' + hasMediaCapability);
      } else if (statusData.has_oauth1_fallback) {
        setHasOAuth1Fallback(true);
        console.info('[ConnectStep] OAuth 1.0a fallback: ENABLED (legacy)');
      } else {
        setHasOAuth1Fallback(false);
      }
      
      // Step 2: If tokens exist and caller wants verify, do live verification
      if (doVerify && statusData.has_tokens && statusData.is_project_scoped) {
        console.info('[ConnectStep] X verify=true starting...');
        const verifyResp = await apiClient.get(`/integrations/x/status?project_id=${projectId}&verify=true`);
        const verifyData = verifyResp.data;
        setXDebugStatus(verifyData);
        
        console.info('[ConnectStep] VERIFY result:', {
          connected: verifyData.connected,
          verified: verifyData.verified,
          token_valid: verifyData.token_valid,
          error: verifyData.error,
          action_required: verifyData.action_required
        });
        
        // P0 FIX: Use connected (tokens exist) as primary check, not token_valid
        if (verifyData.connected && (verifyData.token_valid === true || verifyData.verified === true)) {
          setXUsername(verifyData.x_username);
          finalState = X_STATUS.CONNECTE_VERIFIE;
          console.info('[ConnectStep] X VERIFIED VALID @' + verifyData.x_username);
        } else if (verifyData.connected && (verifyData.token_valid === false || verifyData.verified === false)) {
          // P0 FIX: Tokens exist but verification failed -> still connected, show warning
          finalState = X_STATUS.CONNECTE_NON_VERIFIE;
          console.warn('[ConnectStep] X verification failed but tokens exist - showing as connected with warning');
          console.warn('[ConnectStep] Error:', verifyData.error);
        } else if (!verifyData.connected) {
          finalState = X_STATUS.NON_CONNECTE;
          console.warn('[ConnectStep] X NOT CONNECTED - no tokens');
        } else {
          finalState = X_STATUS.CONNECTE_NON_VERIFIE;
          console.info('[ConnectStep] X verification inconclusive');
        }
      }
      
      setXConnectionState(finalState);
      return { state: finalState, data: statusData };
    } catch (e) {
      console.error('[ConnectStep] X status check error:', e);
      setXConnectionState(X_STATUS.NON_CONNECTE);
      return { state: X_STATUS.NON_CONNECTE, error: e };
    }
  }, [projectId, determineXState]);

  // P0 TRUTHFUL: Execute the actual claim (after confirmation)
  const executeClaimX = useCallback(async () => {
    try {
      setXConnectionState(X_STATUS.EN_COURS);
      setShowClaimConfirmModal(false);
      
      console.info('[ConnectStep] CLAIM starting for project:', projectId);
      
      // Step 1: Call claim endpoint
      const claimResp = await apiClient.post(`/integrations/x/claim?project_id=${projectId}`);
      const claimData = claimResp.data;
      
      console.info('[ConnectStep] CLAIM response:', {
        claimed: claimData.claimed,
        next_action: claimData.next_action,
        token_source: claimData.token_source,
        error: claimData.error,
        x_username: claimData.x_username
      });
      
      if (!claimData.claimed) {
        toast.error(`Échec: ${claimData.message || claimData.error || 'Erreur inconnue'}`);
        
        if (claimData.next_action === 'reconnect' || claimData.reason === 'no_claimable_credentials') {
          setXConnectionState(X_STATUS.NON_CONNECTE);
          setXClaimPossible(false);
        } else if (claimData.reason === 'already_project_scoped') {
          // Already has tokens - need to verify
          toast.info('Ce projet a déjà des credentials. Vérification...');
          await checkXStatus(true);
        } else {
          setXConnectionState(X_STATUS.A_REPARER);
        }
        return;
      }
      
      // Step 2: Claim succeeded - now VERIFY
      toast.info('🔄 Credentials récupérés, vérification en cours...');
      setXUsername(claimData.x_username);
      
      // Step 3: Verify the token
      console.info('[ConnectStep] CLAIM succeeded, now verifying...');
      const verifyResp = await apiClient.get(`/integrations/x/status?project_id=${projectId}&verify=true`);
      const verifyData = verifyResp.data;
      
      console.info('[ConnectStep] VERIFY after claim:', {
        token_valid: verifyData.token_valid,
        token_error: verifyData.token_error,
        action_required: verifyData.action_required
      });
      
      if (verifyData.token_valid === true) {
        toast.success(`✅ X connecté et vérifié ! (@${verifyData.x_username || claimData.x_username})`);
        setXConnectionState(X_STATUS.CONNECTE_VERIFIE);
        setXUsername(verifyData.x_username || claimData.x_username);
        setXClaimPossible(false);
        setPlatformStatuses(prev => ({ ...prev, x_twitter: 'connected' }));
        
        // Refresh project
        const projectResp = await apiClient.get(`/projects/${projectId}`);
        setProject(projectResp.data);
      } else if (verifyData.token_valid === false) {
        toast.error('⚠️ Token X invalide ou expiré. Veuillez reconnecter votre compte.');
        setXConnectionState(X_STATUS.NON_CONNECTE);
        setXClaimPossible(false);
        setPlatformStatuses(prev => ({ ...prev, x_twitter: 'error' }));
      } else {
        toast.warning('Token récupéré mais vérification non concluante. Réessayez.');
        setXConnectionState(X_STATUS.CONNECTE_NON_VERIFIE);
      }
      
    } catch (e) {
      console.error('[ConnectStep] Claim error:', e);
      toast.error('Erreur lors de la récupération des credentials');
      setXConnectionState(X_STATUS.A_REPARER);
    }
  }, [projectId, checkXStatus]);

  // P0: Open claim confirmation modal (for multi-project safety)
  const handleClaimXCredentials = useCallback(() => {
    setShowClaimConfirmModal(true);
  }, []);

  // P0 TRUTHFUL: Handle X verify button (with debounce)
  const handleVerifyX = useCallback(async () => {
    const now = Date.now();
    if (now - lastXVerifyTime < X_VERIFY_DEBOUNCE_MS) {
      const remainingSec = Math.ceil((X_VERIFY_DEBOUNCE_MS - (now - lastXVerifyTime)) / 1000);
      toast.info(`Veuillez attendre ${remainingSec}s avant de revérifier`);
      return;
    }
    setLastXVerifyTime(now);
    
    const result = await checkXStatus(true);
    
    if (result.state === X_STATUS.CONNECTE_VERIFIE) {
      toast.success(`✅ X vérifié ! (@${xUsername})`);
    } else if (result.state === X_STATUS.NON_CONNECTE) {
      toast.error('⚠️ Token X invalide. Veuillez reconnecter.');
    }
  }, [lastXVerifyTime, checkXStatus, xUsername]);

  // P0: Initialize X status on mount
  const checkXStatusAndClaim = async (projectData) => {
    const result = await checkXStatus(false);
    return result.state === X_STATUS.CONNECTE_VERIFIE || result.state === X_STATUS.CONNECTE_NON_VERIFIE;
  };

  // P0 FIX: Handle x_connected URL parameter after OAuth callback
  useEffect(() => {
    const xConnected = searchParams.get('x_connected');
    if (xConnected === 'true') {
      toast.success('✅ X (Twitter) connecté avec succès !');
      // Remove the parameter from URL
      searchParams.delete('x_connected');
      setSearchParams(searchParams, { replace: true });
      
      // P0 TRUTHFUL: After OAuth callback, verify the token AND re-fetch project
      const refreshAfterOAuth = async () => {
        console.info('[ConnectStep] x_connected=true detected, verifying...');
        
        // Step 1: Verify the newly connected token (triggers auto-sync)
        const verifyResp = await apiClient.get(`/integrations/x/status?project_id=${projectId}&verify=true&_ts=${Date.now()}`);
        console.info('[ConnectStep] Post-OAuth verify result:', verifyResp.data);
        setXDebugStatus(verifyResp.data);
        
        if (verifyResp.data.connected) {
          setXUsername(verifyResp.data.x_username);
          setXConnectionState(verifyResp.data.token_valid ? X_STATUS.CONNECTE_VERIFIE : X_STATUS.CONNECTE_NON_VERIFIE);
          setPlatformStatuses(prev => ({ ...prev, x_twitter: 'connected' }));
        }
        
        // Step 2: Re-fetch project (now synced by status endpoint)
        const projectResp = await apiClient.get(`/projects/${projectId}?_ts=${Date.now()}`);
        setProject(projectResp.data);
      };
      
      refreshAfterOAuth();
    }
    
    const xError = searchParams.get('x_error');
    if (xError) {
      const reason = searchParams.get('reason') || '';
      toast.error(`Erreur de connexion X: ${xError}${reason ? ` (${reason})` : ''}`);
      searchParams.delete('x_error');
      searchParams.delete('reason');
      setSearchParams(searchParams, { replace: true });
      setXConnectionState(X_STATUS.NON_CONNECTE);
    }
    
    // P0 REFACTOR: Handle OAuth 1.0a callback (new format: x_oauth1=success|error)
    const xOauth1Result = searchParams.get('x_oauth1');
    if (xOauth1Result === 'success') {
      const screenName = searchParams.get('screen_name');
      toast.success(`✅ X connecté !${screenName ? ` @${screenName}` : ''}`);
      searchParams.delete('x_oauth1');
      searchParams.delete('screen_name');
      setSearchParams(searchParams, { replace: true });
      
      // Refresh X status (async but not awaited in useEffect)
      checkXStatus(false);
    } else if (xOauth1Result === 'error') {
      const errorCode = searchParams.get('code') || 'UNKNOWN_ERROR';
      const errorMessages = {
        'INVALID_VERIFIER': 'Session expirée. Veuillez réessayer.',
        'ACCESS_TOKEN_FAILED': 'Échec de l\'autorisation X.',
        'MISSING_CREDENTIALS': 'Credentials manquants.',
        'CALLBACK_NOT_APPROVED': 'URL de callback non approuvée dans X Developer Portal.'
      };
      toast.error(errorMessages[errorCode] || `Erreur X: ${errorCode}`);
      searchParams.delete('x_oauth1');
      searchParams.delete('code');
      setSearchParams(searchParams, { replace: true });
    }
    
    // P0 LEGACY: Handle old OAuth 1.0a callback format (oauth1_success/oauth1_error)
    const oauth1Success = searchParams.get('oauth1_success');
    if (oauth1Success === 'true') {
      const screenName = searchParams.get('screen_name');
      toast.success(`✅ X connecté !${screenName ? ` @${screenName}` : ''}`);
      searchParams.delete('oauth1_success');
      searchParams.delete('screen_name');
      setSearchParams(searchParams, { replace: true });
      
      // Refresh X status (async but not awaited in useEffect)
      checkXStatus(false);
    }
    
    const oauth1Error = searchParams.get('oauth1_error');
    if (oauth1Error) {
      const message = searchParams.get('message') || 'Erreur OAuth 1.0a';
      toast.error(`🚫 ${oauth1Error}: ${message}`);
      searchParams.delete('oauth1_error');
      searchParams.delete('message');
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, projectId, checkXStatus, setSearchParams]);
  
  // P0 FIX: Listen for global X events (from XOAuth1Modal)
  useEffect(() => {
    const handleXConnected = (event) => {
      console.info('[ConnectStep] X connected event received:', event.detail);
      // Force status refresh
      checkXStatus(false);
    };
    
    const handleXReset = (event) => {
      console.info('[ConnectStep] X reset event received:', event.detail);
      // Reset local state
      setXConnectionState(X_STATUS.NON_CONNECTE);
      setXUsername(null);
      setHasOAuth1Fallback(false);
      // P1 FIX: Reset OAuth 1.0a specific state
      setIsOAuth1Connected(false);
      setMediaUploadCapable(false);
      // Force status refresh
      checkXStatus(false);
    };
    
    window.addEventListener('ame:x-connected', handleXConnected);
    window.addEventListener('ame:x-reset', handleXReset);
    
    return () => {
      window.removeEventListener('ame:x-connected', handleXConnected);
      window.removeEventListener('ame:x-reset', handleXReset);
    };
  }, [checkXStatus]);
  
  // P0 TRUTHFUL: Debug check (for debug panel only) - uses handleVerifyX
  const handleCheckXStatus = async () => {
    await handleVerifyX();
  };
  
  // Handler pour tester une connexion
  const handleTestConnection = async (platformId) => {
    setTestingPlatform(platformId);
    try {
      if (platformId === 'brevo') {
        const response = await apiClient.post('/integrations/brevo/test', {});
        if (response.data?.success) {
          toast.success('✅ Connexion Brevo OK - email de test envoyé !');
        } else {
          toast.error(response.data?.error || 'Échec du test Brevo');
        }
      } else if (platformId === 'telegram') {
        // Test Telegram connection by sending a test message
        const response = await apiClient.post('/integrations/telegram/test', {});
        if (response.data?.success) {
          toast.success('✅ Connexion Telegram OK - message test envoyé !');
        } else {
          toast.error(response.data?.error || 'Échec du test Telegram');
        }
      } else if (platformId === 'facebook') {
        // P1 FIX: Test Facebook post via dedicated endpoint
        const response = await apiClient.post('/social/facebook/test', {
          message: '🧪 Test de publication AI Marketing Engine',
          project_id: projectId
        });
        if (response.data?.success) {
          toast.success('✅ Post de test Facebook publié !');
        } else {
          toast.error(response.data?.error || 'Échec du test Facebook');
        }
      } else if (platformId === 'instagram') {
        // Test Instagram via dedicated endpoint
        const response = await apiClient.post('/social/instagram/test', {
          caption: '🧪 Test de publication AI Marketing Engine',
          project_id: projectId
        });
        if (response.data?.success) {
          toast.success('✅ Post de test Instagram publié !');
        } else {
          toast.error(response.data?.error || 'Échec du test Instagram');
        }
      } else if (platformId === 'pinterest') {
        // P0 FIX: Test Pinterest via dedicated POST endpoint
        console.info('[PINTEREST:UI] test pin request method=POST endpoint=/api/social/pinterest/test');
        const response = await apiClient.post('/social/pinterest/test');
        if (response.data?.success) {
          toast.success(
            <div>
              <strong>✅ Pin de test créé !</strong>
              {response.data.pin_url && (
                <div className="text-sm mt-1">
                  <a href={response.data.pin_url} target="_blank" rel="noopener noreferrer" className="underline">
                    Voir le pin
                  </a>
                </div>
              )}
            </div>
          );
        } else {
          // P0 FIX: Handle specific Pinterest errors without showing reconnection
          const errorMsg = response.data?.error || 'Échec du test Pinterest';
          if (errorMsg.includes('Trial access')) {
            toast.error(
              <div>
                <strong>⚠️ Limitation Pinterest Trial</strong>
                <div className="text-sm mt-1">
                  Votre app Pinterest est en mode Trial. La création de pins en production n'est pas autorisée.
                </div>
              </div>,
              { duration: 8000 }
            );
          } else {
            toast.error(errorMsg);
          }
        }
      } else {
        // Pour les autres plateformes, on vérifie juste le status
        const response = await apiClient.get(`/integrations/${platformId}/status`);
        if (response.data?.connected || response.data?.is_connected || response.data?.token_valid) {
          toast.success(`✅ ${platformId} est bien connecté !`);
        } else {
          toast.error(`⚠️ ${platformId} nécessite une reconnexion`);
        }
      }
    } catch (error) {
      // Better error message extraction - P0 FIX: Avoid JSON.stringify on potentially circular objects
      const errorData = error.response?.data;
      const errorStatus = error.response?.status;
      let errorMsg = 'Erreur lors du test';
      
      // P0 FIX: Handle 405 Method Not Allowed specifically
      if (errorStatus === 405) {
        console.error(`[PINTEREST:UI] classify_error=method_not_allowed status=405`);
        errorMsg = 'Erreur technique (méthode HTTP incorrecte). La connexion du compte est néanmoins active.';
        toast.error(errorMsg);
        setTestingPlatform(null);
        return;
      }
      
      // P0 FIX: Handle Pinterest Trial access message
      if (errorData?.detail && typeof errorData.detail === 'string' && errorData.detail.includes('Trial access')) {
        console.info('[PINTEREST:UI] classify_error=trial_access');
        toast.error(
          <div>
            <strong>⚠️ Limitation Pinterest Trial</strong>
            <div className="text-sm mt-1">
              Le compte Pinterest est connecté, mais votre app Pinterest Developer est en accès Trial. 
              La création de pins en production n'est pas autorisée.
            </div>
          </div>,
          { duration: 8000 }
        );
        setTestingPlatform(null);
        return;
      }
      
      if (errorData?.message) {
        errorMsg = errorData.message;
      } else if (errorData?.detail) {
        // P0 FIX: Don't stringify detail - extract string safely
        errorMsg = typeof errorData.detail === 'string' 
          ? errorData.detail 
          : (errorData.detail?.message || errorData.detail?.error || 'Erreur lors du test');
      } else if (errorData?.error) {
        errorMsg = typeof errorData.error === 'string' ? errorData.error : 'Erreur lors du test';
      } else if (error.message) {
        errorMsg = error.message;
      }
      
      // Add helpful hint for common errors
      if (errorMsg.toLowerCase().includes('clé api invalide') || errorMsg.toLowerCase().includes('401')) {
        errorMsg += ' - Vérifiez les restrictions IP dans votre compte';
      }
      
      // Show user-friendly message
      toast.error(errorMsg);
    } finally {
      setTestingPlatform(null);
    }
  };
  
  // Handler pour déconnecter une plateforme
  const handleDisconnect = async (platformId) => {
    if (!window.confirm(`Voulez-vous déconnecter ${platformId} ? Vous pourrez le reconnecter à tout moment.`)) {
      return;
    }
    
    setDisconnectingPlatform(platformId);
    try {
      // P0 FIX: Use dedicated X disconnect endpoint for complete cleanup
      if (platformId === 'x_twitter' || platformId === 'x' || platformId === 'twitter') {
        console.info('[ConnectStep] Disconnecting X via /integrations/x/disconnect');
        const response = await apiClient.post(`/integrations/x/disconnect?project_id=${projectId}`);
        
        if (response.data.ok || response.data.success) {
          toast.success('X déconnecté. Reconnectez pour obtenir les autorisations média.');
          // Reset X state
          setXConnectionState(X_STATUS.NON_CONNECTE);
          setXUsername('');
          setXDebugStatus(null);
          setPlatformStatuses(prev => ({ ...prev, x_twitter: 'not_connected' }));
        } else {
          throw new Error(response.data.error || 'Erreur lors de la déconnexion');
        }
      } else {
        // Other platforms: update channels_config
        await apiClient.put(`/projects/${projectId}/channels/${platformId}`, {
          enabled: false,
          connected: false
        });
        
        // Supprimer les credentials si c'est brevo
        if (platformId === 'brevo') {
          await apiClient.delete('/integrations/brevo');
        }
        
        // Supprimer les credentials si c'est telegram
        if (platformId === 'telegram') {
          await apiClient.delete('/integrations/telegram');
        }
        
        toast.success(`${platformId} déconnecté`);
      }
      
      loadProject(); // Recharger pour mettre à jour le statut
    } catch (error) {
      console.error('[ConnectStep] Disconnect error:', error);
      toast.error('Erreur lors de la déconnexion: ' + (error.response?.data?.detail || error.message));
    } finally {
      setDisconnectingPlatform(null);
    }
  };
  
  // P0 NEW: Handler pour poster un tweet de test
  // P1 FIX: test_media=true by default to test full OAuth 1.0a capability including image upload
  const handleTestXPost = useCallback(async (withImage = true) => {
    if (!projectId) {
      toast.error('ID de projet manquant');
      return;
    }
    
    setXTestPosting(true);
    try {
      console.info('[ConnectStep] handleTestXPost: Starting test post...', { withImage });
      
      const response = await apiClient.post('/integrations/x/test_post', {
        project_id: projectId,
        test_media: withImage  // P1: Explicitly pass test_media option
      });
      
      if (response.data.ok) {
        const tweetId = response.data.tweet_id;
        const mediaUploaded = response.data.media_uploaded;
        const imageUrlUsed = response.data.image_url_used;
        const username = response.data.screen_name || response.data.x_username || xUsername;
        
        toast.success(
          <div>
            <strong>✅ Tweet publié avec succès !</strong>
            <br />
            <span className="text-sm opacity-80">ID: {tweetId}</span>
            {username && <span className="text-sm opacity-80"> @{username}</span>}
            {mediaUploaded && (
              <div className="mt-1 text-xs opacity-70">
                🖼️ Image uploadée
                {imageUrlUsed && <span className="block truncate max-w-[200px]">{imageUrlUsed.substring(0, 50)}...</span>}
              </div>
            )}
          </div>,
          { duration: 6000 }
        );
        console.info('[ConnectStep] ✅ Test post success:', { tweetId, mediaUploaded, imageUrlUsed, username });
      } else {
        throw new Error(response.data.error || 'Erreur inconnue');
      }
    } catch (error) {
      // P0 FIX: Extract error info safely without any JSON.stringify that could fail on circular refs
      const errorData = error.response?.data || error.errorInfo || {};
      const httpStatus = errorData.http_status || error.response?.status;
      const requestId = errorData.request_id || '';
      const errorCode = errorData.error_code || '';
      const actionRequired = errorData.action_required || '';
      
      // P0 FIX: Extract error message safely - never stringify complex objects
      let xError = 'Erreur';
      let xDetail = '';
      
      if (typeof errorData.x_error === 'string') {
        xError = errorData.x_error;
      }
      if (typeof errorData.x_detail === 'string') {
        xDetail = errorData.x_detail;
      } else if (typeof errorData.error === 'string') {
        xDetail = errorData.error;
      } else if (typeof errorData.message === 'string') {
        xDetail = errorData.message;
      } else if (typeof error.message === 'string') {
        xDetail = error.message;
      } else {
        xDetail = 'Erreur de connexion X';
      }
      
      // P0 FIX: Log safely with only primitive values
      console.error('[X_TEST_POST] ❌ Error:', {
        httpStatus,
        errorCode,
        xError,
        xDetail: xDetail?.substring?.(0, 200) || xDetail,
        requestId,
        actionRequired
      });
      
      // P0 FIX: Handle 405 METHOD_NOT_ALLOWED explicitly
      if (httpStatus === 405 || errorCode === 'HTTP_405' || errorData.error === 'METHOD_NOT_ALLOWED') {
        console.error('[ConnectStep] ⚠️ 405 METHOD_NOT_ALLOWED detected - client bug?', {
          request_id: requestId,
          expected_method: errorData.expected_method,
          received_method: errorData.received_method,
          client_hint: errorData.client_hint
        });
        
        toast.error(
          <div>
            <strong>Bug client: méthode incorrecte (POST requis)</strong>
            <br />
            <span className="text-sm opacity-80">{errorData.client_hint || 'Vérifiez que le bouton utilise fetch POST'}</span>
            {requestId && <div className="text-xs opacity-60 mt-1">ref: {requestId}</div>}
          </div>,
          { duration: 8000 }
        );
        return;
      }
      
      // Build user-friendly error message
      let errorMsg = xDetail || xError;
      let showOAuth1Button = false;
      let showUpgradeLink = false;
      
      // P0 FIX v2: Handle specific action_required codes
      if (errorCode === 'X_MEDIA_UPLOAD_FORBIDDEN') {
        switch (actionRequired) {
          case 'CONFIGURE_OAUTH1':
            errorMsg = "L'API X bloque l'upload d'image (plan Basic/Free). Configurez le fallback OAuth 1.0a.";
            showOAuth1Button = true;
            break;
          case 'OAUTH1_INVALID':
            errorMsg = "Credentials OAuth 1.0a invalides. Régénérez vos tokens dans le X Developer Portal.";
            showOAuth1Button = true;
            showUpgradeLink = true;
            break;
          case 'OAUTH1_MISSING':
            errorMsg = "Credentials OAuth 1.0a incomplets. Vérifiez que tous les champs sont remplis.";
            showOAuth1Button = true;
            break;
          default:
            errorMsg = "L'upload média est refusé par l'API X. Configurez OAuth 1.0a ou upgradez votre plan.";
            showOAuth1Button = true;
            showUpgradeLink = true;
        }
      } else if (errorCode === 'X_DUPLICATE_CONTENT') {
        // P0 FIX: Specific handling for duplicate content error (403)
        errorMsg = "X refuse un tweet identique. Modifiez légèrement le texte puis réessayez.";
      } else if (errorCode === 'RATE_LIMITED') {
        // P0 FIX: Rate limit handling
        errorMsg = "Limite de requêtes X atteinte. Réessayez dans quelques minutes.";
      } else {
        // Handle other action codes
        switch (actionRequired) {
          case 'REAUTH':
            errorMsg = 'Session expirée. Veuillez reconnecter votre compte X.';
            break;
          case 'WAIT_RETRY':
            errorMsg = 'Limite de requêtes X atteinte. Réessayez dans quelques minutes.';
            break;
          case 'FIX_IMAGE':
            errorMsg = errorData.message || 'Problème avec l\'image. Vérifiez le format et la taille.';
            break;
          case 'CHECK_IMAGE_URL':
            errorMsg = 'Impossible de télécharger l\'image. Vérifiez l\'URL.';
            break;
          case 'CHECK_APP_PERMISSIONS':
            errorMsg = 'Permissions insuffisantes. Vérifiez les paramètres de votre app X.';
            showUpgradeLink = true;
            break;
          case 'UPGRADE_PLAN':
          case 'UPGRADE_X_PLAN':
            errorMsg = 'Action non autorisée. Votre app X nécessite peut-être un niveau d\'accès supérieur.';
            showUpgradeLink = true;
            break;
          default:
            // Keep original error message
            break;
        }
      }
      
      // Show toast with action buttons - P0 FIX: Show actual error, not N/A
      const statusDisplay = httpStatus || errorCode || '';
      toast.error(
        <div className="space-y-2">
          <div>
            <strong>Échec X{statusDisplay ? ` (${statusDisplay})` : ''}</strong>
            <br />
            <span className="text-sm opacity-80">{errorMsg}</span>
          </div>
          {showOAuth1Button && (
            <button 
              onClick={() => setShowOAuth1FallbackModal(true)}
              className="text-xs bg-orange-500/20 hover:bg-orange-500/30 text-orange-300 px-2 py-1 rounded"
            >
              Configurer OAuth 1.0a
            </button>
          )}
          {showUpgradeLink && (
            <a 
              href="https://developer.x.com/en/portal/dashboard" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xs text-blue-400 hover:underline block"
            >
              Ouvrir X Developer Portal →
            </a>
          )}
          {requestId && <span className="text-xs opacity-60 block">ref: {requestId}</span>}
        </div>,
        { duration: 12000 }
      );
      
      // If reauth needed, update state
      if (actionRequired === 'REAUTH') {
        setXConnectionState(X_STATUS.NON_CONNECTE);
        checkXStatus(false); // Refresh status
      }
    } finally {
      setXTestPosting(false);
    }
  }, [projectId, xUsername, checkXStatus]);
  
  // Toggle for manual platforms like WhatsApp (no API needed)
  const handleToggleManualPlatform = async (platformId) => {
    setConnectingPlatform(platformId);
    try {
      const currentStatus = platformStatuses[platformId];
      const newEnabled = currentStatus !== 'connected';
      
      await apiClient.put(`/projects/${projectId}/channels/${platformId}`, {
        enabled: newEnabled,
        connected: newEnabled,
        manual_only: true  // Flag to indicate no API integration
      });
      
      toast.success(newEnabled 
        ? `${platformId} activé ! Utilisez "Copier" pour publier manuellement.`
        : `${platformId} désactivé`
      );
      loadProject();
    } catch (error) {
      toast.error('Erreur lors de l\'activation');
    } finally {
      setConnectingPlatform(null);
    }
  };
  
  // P0 PROD FIX: State for debug panel
  const [xDebugData, setXDebugData] = useState(null);
  const [loadingDebug, setLoadingDebug] = useState(false);
  
  // P0 PROD FIX: Handle URL params x_connected and x_error from OAuth callback
  useEffect(() => {
    const xConnected = searchParams.get('x_connected');
    const xError = searchParams.get('x_error');
    const errorReason = searchParams.get('reason');
    const errorMsg = searchParams.get('x_msg');
    const rid = searchParams.get('rid');
    
    if (xConnected === 'true') {
      console.info('[ConnectStep] OAuth SUCCESS detected via URL param');
      toast.success('✅ X (Twitter) connecté avec succès !');
      // Clear URL params and reload project
      setSearchParams({});
      loadProject();
      checkXStatus(true);
    } else if (xError) {
      console.error('[ConnectStep] OAuth ERROR detected:', { xError, errorReason, errorMsg, rid });
      
      // Map error codes to user-friendly messages
      const errorMessages = {
        'X_DENIED': 'Autorisation X refusée. Vous devez autoriser l\'application.',
        'INVALID_STATE': 'Session expirée ou invalide. Veuillez réessayer.',
        'STATE_EXPIRED': 'Session expirée. Veuillez réessayer.',
        'TOKEN_EXCHANGE_FAILED': 'Échec de l\'échange de token avec X. Vérifiez vos credentials.',
        'PROJECT_UPDATE_FAILED': 'Erreur lors de la mise à jour du projet.',
        'DB_WRITE_FAILED': 'Erreur d\'enregistrement. Réessayez.',
        'NO_CREDENTIALS': 'Configurez d\'abord votre App X (Client ID/Secret).',
        'CREDENTIALS_INVALID': 'Credentials X invalides. Vérifiez votre configuration.',
        'MISSING_CODE': 'Paramètres OAuth manquants.',
        'MISSING_STATE': 'Session OAuth invalide.',
        'NO_PROJECT_ID': 'Erreur: projet non identifié. Réessayez depuis cette page.',
        'CALLBACK_ERROR': 'Erreur inattendue. Consultez les logs.'
      };
      
      const userMessage = errorMessages[xError] || `Erreur OAuth: ${xError}`;
      toast.error(userMessage, {
        duration: 8000,
        description: errorReason ? `Raison: ${errorReason.replace(/_/g, ' ')}` : undefined
      });
      
      // Clear URL params but keep debug mode if enabled
      const newParams = {};
      if (searchParams.get('debug') === '1') {
        newParams.debug = '1';
      }
      setSearchParams(newParams);
      
      // Set state to show retry button
      setXConnectionState(X_STATUS.NON_CONNECTE);
      
      // If debug mode, auto-load debug info
      if (isDebugMode) {
        loadXDebugInfo();
      }
    }
  }, [searchParams]);
  
  // P0 PROD FIX: Load debug info from /integrations/x/debug
  const loadXDebugInfo = async () => {
    if (!projectId) return;
    setLoadingDebug(true);
    try {
      const resp = await apiClient.get(`/integrations/x/debug?project_id=${projectId}`);
      setXDebugData(resp.data);
      console.info('[ConnectStep] Debug data:', resp.data);
    } catch (e) {
      console.error('[ConnectStep] Debug load failed:', e);
      setXDebugData({ error: e.message });
    } finally {
      setLoadingDebug(false);
    }
  };
  
  useEffect(() => {
    loadProject();
    // Auto-load debug in debug mode
    if (isDebugMode) {
      loadXDebugInfo();
    }
  }, [projectId]);
  
  // P0 UX OVERHAUL: Listen for platform connected events to refresh
  useEffect(() => {
    const handlePlatformConnected = () => {
      loadProject();
    };
    
    window.addEventListener('ame:platform-connected', handlePlatformConnected);
    return () => window.removeEventListener('ame:platform-connected', handlePlatformConnected);
  }, []);
  
  const loadProject = async () => {
    // P0 FIX: Guard against invalid projectId
    if (!projectId || isInvalidProjectId(projectId)) {
      console.error('[ConnectStep] ❌ Cannot load project - invalid projectId:', projectId);
      setLoading(false);
      return;
    }
    
    try {
      // P0 FIX: Add cache-bust timestamp to prevent stale iOS Safari data
      const cacheBust = Date.now();
      const response = await apiClient.get(`/projects/${projectId}?_ts=${cacheBust}`);
      setProject(response.data);
      
      // P0 FIX: Persist projectId after successful load
      persistProjectId(projectId);
      
      // Determine platform statuses from channels_config (SINGLE SOURCE OF TRUTH)
      const statuses = {};
      const channels = response.data.channels_config || {};
      
      // P0 PROD FIX: Enhanced debug logging (no secrets)
      const xTwitterCfg = channels.x_twitter || {};
      const legacyXCfg = channels.x || {};
      const configKeys = Object.keys(channels).sort();
      
      console.info('[ConnectStep] BUILD=' + (window.__BUILD_MARKER__ || '20260308_p0_x_state_persistence_fix'));
      console.info('[ConnectStep] channels_config keys:', configKeys);
      console.info('[ConnectStep] x_twitter present:', 'x_twitter' in channels);
      console.info('[ConnectStep] x_twitter.connected=' + xTwitterCfg.connected + 
                   ', x_twitter.enabled=' + xTwitterCfg.enabled);
      
      // Only log legacy if it exists (for migration debugging)
      if ('x' in channels) {
        console.info('[ConnectStep] legacy_x.connected=' + legacyXCfg.connected + 
                     ', legacy_x.enabled=' + legacyXCfg.enabled +
                     ', legacy_x.has_token=' + !!legacyXCfg.access_token);
      }
      
      // P0 FIX: ALWAYS fetch X status from backend (SOURCE OF TRUTH for X)
      // This is more accurate than channels_config and triggers auto-sync
      let xConnectedFromStatus = false;
      try {
        const xStatusResp = await apiClient.get(`/integrations/x/status?project_id=${projectId}&verify=false&_ts=${cacheBust}`);
        const xStatusData = xStatusResp.data;
        console.info('[ConnectStep] X status from backend:', {
          connected: xStatusData.connected,
          has_tokens: xStatusData.has_tokens,
          has_oauth1_tokens: xStatusData.has_oauth1_tokens,
          media_upload_capable: xStatusData.media_upload_capable,
          auth_type: xStatusData.auth_type,
          oauth1_connected: xStatusData.oauth1?.connected,
          screen_name: xStatusData.screen_name || xStatusData.x_username,
          build_marker: xStatusData.build_marker
        });
        
        setXDebugStatus(xStatusData);
        
        // =====================================================================
        // P0 CRITICAL FIX: Set ALL X-related state from backend response
        // This was the ROOT CAUSE of the state persistence bug
        // =====================================================================
        
        // 1. Set media upload capability from backend (THE FIX)
        const hasMediaCapability = xStatusData.media_upload_capable === true;
        setMediaUploadCapable(hasMediaCapability);
        console.info('[ConnectStep] mediaUploadCapable set to:', hasMediaCapability);
        
        // 2. Set OAuth 1.0a connection status
        const isOAuth1Auth = xStatusData.auth_type === 'oauth1';
        const oauth1Connected = xStatusData.oauth1?.connected === true;
        setIsOAuth1Connected(isOAuth1Auth && oauth1Connected);
        
        // 3. Set OAuth 1.0a fallback status
        if (oauth1Connected || hasMediaCapability) {
          setHasOAuth1Fallback(true);
        } else if (xStatusData.has_oauth1_fallback) {
          setHasOAuth1Fallback(true);
        } else {
          setHasOAuth1Fallback(false);
        }
        
        // 4. Determine X connection state properly
        xConnectedFromStatus = xStatusData.connected === true;
        const hasOAuth1Tokens = xStatusData.has_oauth1_tokens === true;
        
        if (xConnectedFromStatus || hasOAuth1Tokens) {
          // Set username
          const username = xStatusData.oauth1?.screen_name || xStatusData.screen_name || xStatusData.x_username;
          if (username) setXUsername(username);
          
          // P0 FIX: If tokens exist and auth_type is oauth1, consider it VERIFIED
          // because OAuth 1.0a tokens don't expire like OAuth 2.0
          if (isOAuth1Auth && oauth1Connected) {
            setXConnectionState(X_STATUS.CONNECTE_VERIFIE);
            console.info('[ConnectStep] ✅ X VERIFIED (OAuth 1.0a connected)');
          } else if (xStatusData.last_verified_at) {
            // Was verified before, trust it until proven otherwise
            setXConnectionState(X_STATUS.CONNECTE_VERIFIE);
            console.info('[ConnectStep] ✅ X VERIFIED (has last_verified_at)');
          } else {
            setXConnectionState(X_STATUS.CONNECTE_NON_VERIFIE);
            console.info('[ConnectStep] X connected but not verified yet');
          }
        } else if (xStatusData.has_tokens) {
          // Has some tokens but not connected - need verification
          setXConnectionState(X_STATUS.CONNECTE_NON_VERIFIE);
        } else {
          setXConnectionState(X_STATUS.NON_CONNECTE);
        }
        
      } catch (xErr) {
        console.warn('[ConnectStep] X status fetch error:', xErr);
        // Fallback to channels_config for X
        xConnectedFromStatus = xTwitterCfg.connected === true;
        // Don't change mediaUploadCapable on error - keep previous value
      }
      
      // P1 FIX: Fetch Facebook status from dedicated API (SOURCE OF TRUTH for Facebook)
      // Facebook uses facebook_credentials collection, not channels_config
      let fbConnected = false;
      try {
        const fbStatusResp = await apiClient.get(`/integrations/facebook/status?_ts=${cacheBust}`);
        const fbStatus = fbStatusResp.data;
        console.info('[ConnectStep] Facebook status from backend:', {
          has_page_token: fbStatus.has_page_token,
          can_publish: fbStatus.can_publish,
          page_id: fbStatus.page_id,
          page_name: fbStatus.page_name
        });
        // Facebook is connected if: has_page_token AND can_publish
        fbConnected = fbStatus.has_page_token === true && fbStatus.can_publish === true;
      } catch (fbErr) {
        console.warn('[ConnectStep] Facebook status fetch error:', fbErr);
      }
      
      // P1 FIX: Fetch Instagram status from dedicated API (SOURCE OF TRUTH for Instagram)
      // Instagram uses instagram_credentials + complex chain validation
      let igConnected = false;
      try {
        const igStatusResp = await apiClient.get(`/social/instagram/status?_ts=${cacheBust}`);
        const igStatus = igStatusResp.data;
        console.info('[ConnectStep] Instagram status from backend:', {
          publish_ready: igStatus.publish_ready,
          instagram_account_id: igStatus.instagram_account_id || igStatus.selected_ig_business_id,
          ig_username: igStatus.ig_username,
          user_token_ok: igStatus.user_token_ok,
          selected_page_id: igStatus.selected_page_id,
          blocking_reason: igStatus.blocking_reason
        });
        // Instagram is connected if: publish_ready OR (has IG business ID AND page)
        igConnected = igStatus.publish_ready === true || 
                      (igStatus.selected_ig_business_id && igStatus.selected_page_id);
      } catch (igErr) {
        console.warn('[ConnectStep] Instagram status fetch error:', igErr);
      }
      
      // Pinterest: Fetch status from dedicated API
      let pinterestConnected = false;
      let pinterestBoardSelected = false;
      try {
        const pinterestStatusResp = await apiClient.get(`/integrations/pinterest/status?_ts=${cacheBust}`);
        const pinterestStatus = pinterestStatusResp.data;
        console.info('[ConnectStep] Pinterest status from backend:', {
          has_credentials: pinterestStatus.has_credentials,
          token_valid: pinterestStatus.token_valid,
          default_board_id: pinterestStatus.default_board_id,
          username: pinterestStatus.username
        });
        // Pinterest is connected if: has_credentials AND token_valid AND has board
        pinterestConnected = pinterestStatus.has_credentials === true && 
                            pinterestStatus.token_valid === true;
        pinterestBoardSelected = !!pinterestStatus.default_board_id;
      } catch (pinterestErr) {
        console.warn('[ConnectStep] Pinterest status fetch error:', pinterestErr);
      }
      
      PLATFORMS.forEach(platform => {
        const config = channels[platform.id];
        
        // P0 FIX: For X, use status API result as source of truth
        if (platform.id === 'x_twitter') {
          if (xConnectedFromStatus || config?.connected === true) {
            statuses[platform.id] = 'connected';
            console.info('[ConnectStep] ✅ x_twitter is CONNECTED (source: status API or channels_config)');
          } else if (config?.error) {
            statuses[platform.id] = 'error';
          } else {
            statuses[platform.id] = 'not_connected';
          }
        } else if (platform.id === 'facebook') {
          // P1 FIX: Facebook uses dedicated status API, not channels_config
          if (fbConnected) {
            statuses[platform.id] = 'connected';
            console.info('[ConnectStep] ✅ facebook is CONNECTED (source: status API)');
          } else if (config?.error) {
            statuses[platform.id] = 'error';
          } else {
            statuses[platform.id] = 'not_connected';
          }
        } else if (platform.id === 'instagram') {
          // P1 FIX: Instagram uses dedicated status API, not channels_config
          if (igConnected) {
            statuses[platform.id] = 'connected';
            console.info('[ConnectStep] ✅ instagram is CONNECTED (source: status API)');
          } else if (config?.error) {
            statuses[platform.id] = 'error';
          } else {
            statuses[platform.id] = 'not_connected';
          }
        } else if (platform.id === 'pinterest') {
          // Pinterest uses dedicated status API
          if (pinterestConnected && pinterestBoardSelected) {
            statuses[platform.id] = 'connected';
            console.info('[ConnectStep] ✅ pinterest is CONNECTED (source: status API)');
          } else if (pinterestConnected && !pinterestBoardSelected) {
            statuses[platform.id] = 'partial'; // Connected but no board selected
            console.info('[ConnectStep] ⚠️ pinterest PARTIAL - need board selection');
          } else if (config?.error) {
            statuses[platform.id] = 'error';
          } else {
            statuses[platform.id] = 'not_connected';
          }
        } else {
          // Other platforms: Read from channels_config
          if (config?.connected === true) {
            statuses[platform.id] = 'connected';
            console.info(`[ConnectStep] ✅ ${platform.id} is CONNECTED`);
          } else if (config?.error) {
            statuses[platform.id] = 'error';
          } else {
            statuses[platform.id] = 'not_connected';
          }
        }
      });
      
      setPlatformStatuses(statuses);
      
      // P1 NEW: Load recommended channels from project and use for sorting
      const projectRecommendedChannels = response.data.recommended_channels || [];
      const analysisRecommendations = response.data.analysis_result?.channel_recommendations || [];
      
      if (projectRecommendedChannels.length > 0) {
        setRecommendedChannels(projectRecommendedChannels);
        setHasRecommendations(true);
        console.info('[ConnectStep] Using recommended channel order:', projectRecommendedChannels);
      } else if (analysisRecommendations.length > 0) {
        // Extract channel IDs from analysis recommendations
        const channelIds = analysisRecommendations.map(r => r.channel).filter(Boolean);
        setRecommendedChannels(channelIds);
        setHasRecommendations(true);
        console.info('[ConnectStep] Using analysis recommendations:', channelIds);
      }
      
      // Check if at least one platform is connected
      const hasConnected = Object.values(statuses).some(s => s === 'connected');
      if (hasConnected) {
        setStepStatus('connect', 'completed');
      }
    } catch (error) {
      console.error('[ConnectStep] Load error:', error);
      toast.error('Erreur lors du chargement');
    } finally {
      setLoading(false);
    }
  };
  
  const handleConfigureWithAI = (platformId) => {
    // Dispatch event to open assistant with platform context
    window.dispatchEvent(new CustomEvent('ame:open-assistant'));
    window.dispatchEvent(new CustomEvent('ame:assistant-event', {
      detail: { type: 'CLICK_CONFIGURE_PLATFORM', payload: { platform: platformId } }
    }));
    toast.info('L\'assistant IA va vous guider pour la configuration');
  };
  
  const handleConnect = async (platformId) => {
    // P0 UX OVERHAUL v2: Dispatch event with complete payload
    const eventId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    
    window.dispatchEvent(new CustomEvent('ame:open-platform-modal', {
      detail: { 
        platform: platformId,
        projectId: projectId,
        source: 'connect-step',
        eventId: eventId // Prevent duplicate handling
      }
    }));
    
    // Also emit event to assistant for contextual help
    window.dispatchEvent(new CustomEvent('ame:assistant-event', {
      detail: { 
        type: 'CLICK_CONFIGURE_PLATFORM', 
        payload: { platform: platformId, projectId }
      }
    }));
  };
  
  const handleDiagnose = async (platformId) => {
    try {
      const response = await apiClient.get(`/integrations/${platformId}/diagnose`, {
        params: { project_id: projectId }
      });
      
      // Show diagnosis result
      toast.info(`Diagnostic: ${response.data.message || 'Vérification terminée'}`);
    } catch (error) {
      toast.error('Erreur lors du diagnostic');
    }
  };
  
  const handleContinue = () => {
    navigate(`/projects/${projectId}/setup/campaign`);
  };
  
  const toggleAdvanced = (platformId) => {
    setShowAdvanced(prev => ({
      ...prev,
      [platformId]: !prev[platformId]
    }));
  };
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader2 className="w-8 h-8 animate-spin" style={{ color: 'hsl(var(--color-primary))' }} />
      </div>
    );
  }
  
  const connectedCount = Object.values(platformStatuses).filter(s => s === 'connected').length;
  const hasAnyConnected = connectedCount > 0;
  
  return (
    <div className="max-w-3xl mx-auto">
      <SectionHeader
        title="Connecter mes comptes"
        subtitle="Reliez vos réseaux sociaux pour la publication automatique"
      />

      {/* iter 241 Lot 4 — engine picker + engine-scoped platform panel.
          Hidden if Multimoteur V2 is OFF (legacy fallback). */}
      <div className="flex items-center justify-between mb-4 gap-3 flex-wrap">
        <EngineSelector projectId={projectId} />
        <div className="text-xs text-semantic-muted">
          Activation par moteur : un compte connecté au projet n&apos;est pas actif partout
        </div>
      </div>
      <EnginePlatformsPanel projectId={projectId} />
      
      {/* P0: Claim confirmation modal */}
      {showClaimConfirmModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-md mx-4 shadow-2xl">
            <h3 className="text-lg font-semibold mb-3 text-gray-900 dark:text-white">
              Attribuer le compte X détecté ?
            </h3>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              Un compte X a été détecté{xDebugStatus?.debug?.user_only_username ? ` (@${xDebugStatus.debug.user_only_username})` : ''}. 
              Voulez-vous l'attribuer au projet <strong>"{project?.name || projectId}"</strong> ?
            </p>
            <div className="flex gap-3 justify-end">
              <PillButton
                variant="secondary"
                onClick={() => setShowClaimConfirmModal(false)}
              >
                Annuler
              </PillButton>
              <PillButton
                variant="primary"
                onClick={executeClaimX}
                className="bg-orange-500 hover:bg-orange-600"
              >
                Confirmer
              </PillButton>
            </div>
          </div>
        </div>
      )}
      
      {/* P0 NEW: OAuth 1.0a Fallback Modal */}
      <XOAuth1FallbackModal
        isOpen={showOAuth1FallbackModal}
        onClose={() => setShowOAuth1FallbackModal(false)}
        projectId={projectId}
        onSaved={() => {
          loadProject(); // Refresh to get updated status
        }}
      />
      
      {/* P0 DEBUG: Only visible in debug mode (?debug=1 or non-prod) */}
      {isDebugMode && (
        <div className="mb-4 p-3 bg-gray-100 dark:bg-gray-800 rounded-lg text-xs font-mono">
          <div className="flex items-center justify-between mb-2">
            <span className="text-gray-500">Project: {projectId}</span>
            <button
              onClick={() => checkXStatus(true)}
              disabled={xConnectionState === X_STATUS.EN_COURS}
              className="px-2 py-1 bg-blue-500 text-white rounded text-xs hover:bg-blue-600 disabled:opacity-50"
            >
              {xConnectionState === X_STATUS.EN_COURS ? '⏳' : '🔍'} Vérifier X
            </button>
          </div>
          {xDebugStatus && (
            <div className="mt-2 p-2 bg-white dark:bg-gray-900 rounded border text-xs overflow-auto max-h-48">
              <div><strong>connected:</strong> {String(xDebugStatus.connected)}</div>
              <div><strong>has_tokens:</strong> {String(xDebugStatus.has_tokens)}</div>
              <div><strong>claim_possible:</strong> {String(xDebugStatus.claim_possible)}</div>
              <div><strong>claim_reason:</strong> {xDebugStatus.claim_reason || 'N/A'}</div>
              <div><strong>token_source:</strong> {xDebugStatus.debug?.token_source || 'N/A'}</div>
              <div><strong>user_only_exists:</strong> {String(xDebugStatus.debug?.user_only_exists)}</div>
              <div><strong>x_username:</strong> {xDebugStatus.x_username || xDebugStatus.debug?.user_only_username || 'N/A'}</div>
              <div><strong>xConnectionState:</strong> {xConnectionState}</div>
              {/* P0 NEW: Refresh token info */}
              <div><strong>has_refresh_token:</strong> <span className={xDebugStatus.has_refresh_token ? 'text-green-500' : 'text-orange-500'}>{String(xDebugStatus.has_refresh_token)}</span></div>
              <div><strong>needs_refresh:</strong> <span className={xDebugStatus.needs_refresh ? 'text-orange-500' : 'text-green-500'}>{String(xDebugStatus.needs_refresh)}</span></div>
              <div><strong>expires_at:</strong> {xDebugStatus.expires_at || 'N/A'}</div>
              <div><strong>last_refresh_at:</strong> {xDebugStatus.last_refresh_at || 'N/A'}</div>
              <div><strong>build_marker:</strong> {xDebugStatus.build_marker}</div>
              {xDebugStatus.token_error && <div className="text-red-500"><strong>token_error:</strong> {xDebugStatus.token_error}</div>}
            </div>
          )}
        </div>
      )}
      
      {/* Progress Info */}
      <GlassCard className="p-5 mb-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div 
              className="w-12 h-12 rounded-xl flex items-center justify-center"
              style={{ 
                backgroundColor: hasAnyConnected 
                  ? 'hsl(var(--color-success-bg))' 
                  : 'hsl(var(--color-info-bg))'
              }}
            >
              {hasAnyConnected ? (
                <CheckCircle className="w-6 h-6" style={{ color: 'hsl(var(--color-success))' }} />
              ) : (
                <Link2 className="w-6 h-6" style={{ color: 'hsl(var(--color-primary))' }} />
              )}
            </div>
            <div>
              <p className="font-semibold text-semantic">
                {connectedCount} plateforme{connectedCount > 1 ? 's' : ''} connectée{connectedCount > 1 ? 's' : ''}
              </p>
              <p className="text-sm text-semantic-muted">
                {hasAnyConnected 
                  ? 'Vous pouvez ajouter d\'autres plateformes ou continuer' 
                  : 'Connectez au moins une plateforme pour continuer'}
              </p>
            </div>
          </div>
          {hasAnyConnected && (
            <StatusChip status="success">Prêt</StatusChip>
          )}
        </div>
      </GlassCard>
      
      {/* Difficulty Legend */}
      <DifficultyLegend />
      
      {/* P1 NEW: Recommendation banner if available */}
      {hasRecommendations && (
        <div 
          className="mb-4 p-3 rounded-xl flex items-center gap-3"
          style={{
            background: 'linear-gradient(90deg, hsl(var(--color-primary) / 0.1), hsl(280 60% 55% / 0.1))',
            border: '1px solid hsl(var(--color-primary) / 0.2)'
          }}
        >
          <Sparkles className="w-5 h-5" style={{ color: 'hsl(var(--color-primary))' }} />
          <p className="text-sm text-semantic">
            <span className="font-medium">Canaux triés par pertinence</span>
            <span className="text-semantic-muted ml-1">— basé sur l'analyse de votre site</span>
          </p>
        </div>
      )}
      
      {/* Platform Cards - SORTED BY RECOMMENDATIONS OR DIFFICULTY */}
      <div className="space-y-4 mb-8">
        {(() => {
          // P1 NEW: Sort platforms by recommendations if available
          let sortedPlatforms = [...PLATFORMS];
          
          if (recommendedChannels.length > 0) {
            sortedPlatforms.sort((a, b) => {
              const aIndex = recommendedChannels.indexOf(a.id);
              const bIndex = recommendedChannels.indexOf(b.id);
              
              // If both are in recommendations, sort by recommendation order
              if (aIndex !== -1 && bIndex !== -1) {
                return aIndex - bIndex;
              }
              // Recommended channels come first
              if (aIndex !== -1) return -1;
              if (bIndex !== -1) return 1;
              // Otherwise maintain original order
              return 0;
            });
          }
          
          return sortedPlatforms;
        })().map((platform, platformIndex) => {
          const status = platformStatuses[platform.id] || 'not_connected';
          const isConnecting = connectingPlatform === platform.id;
          const Logo = platform.Logo;
          const isManual = platform.manualOnly;
          
          // P1 NEW: Check if this platform is recommended
          const recommendationIndex = recommendedChannels.indexOf(platform.id);
          const isHighlyRecommended = recommendationIndex >= 0 && recommendationIndex < 3;
          
          return (
            <GlassCard 
              key={platform.id} 
              className={cn(
                "overflow-hidden",
                isHighlyRecommended && "ring-1 ring-[hsl(var(--color-primary)_/_0.3)]"
              )} 
              data-testid={`platform-card-${platform.id}`}
              style={isHighlyRecommended ? {
                background: 'linear-gradient(135deg, hsl(var(--color-surface-2)), hsl(var(--color-primary) / 0.03))'
              } : undefined}
            >
              {/* Main Row */}
              <div className="p-5">
                <div className="flex items-start justify-between gap-4">
                  {/* Platform Info */}
                  <div className="flex items-start gap-4 flex-1">
                    <div 
                      className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                      style={{ background: platform.gradient }}
                    >
                      <Logo className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="font-semibold text-semantic">{platform.name}</h3>
                        {/* Difficulty Badge */}
                        <DifficultyBadge difficulty={platform.setupDifficulty} />
                        {/* P1 NEW: Recommended Badge */}
                        {isHighlyRecommended && (
                          <span 
                            className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium"
                            style={{
                              backgroundColor: 'hsl(var(--color-success) / 0.1)',
                              color: 'hsl(var(--color-success))',
                              border: '1px solid hsl(var(--color-success) / 0.2)'
                            }}
                          >
                            <Sparkles className="w-3 h-3" />
                            Recommandé
                          </span>
                        )}
                      </div>
                      {/* Short hint about setup */}
                      <p className="text-xs text-semantic-muted mt-0.5">{platform.shortHint}</p>
                      {/* Description */}
                      <p className="text-sm text-semantic-2 mt-1">{platform.description}</p>
                    </div>
                  </div>
                  
                  {/* Status + Actions */}
                  <div className="flex flex-col items-end gap-2">
                    {/* Status Chip - Special for WhatsApp and X claim */}
                    {isManual ? (
                      status === 'connected' ? (
                        <StatusChip status="info">Mode manuel</StatusChip>
                      ) : (
                        <StatusChip status="neutral">Non activé</StatusChip>
                      )
                    ) : platform.id === 'x_twitter' ? (
                      // P0 TRUTHFUL: X-specific status chips based on xConnectionState
                      xConnectionState === X_STATUS.EN_COURS ? (
                        <StatusChip status="info">⏳ En cours...</StatusChip>
                      ) : xConnectionState === X_STATUS.A_REPARER ? (
                        <StatusChip status="warning">⚠️ À réparer</StatusChip>
                      ) : xConnectionState === X_STATUS.CONNECTE_VERIFIE ? (
                        <div className="flex flex-col items-end gap-1">
                          <StatusChip status="success">✅ Connecté{xUsername ? ` @${xUsername}` : ''}</StatusChip>
                          {/* P1 FIX: Use mediaUploadCapable from backend as source of truth */}
                          {mediaUploadCapable ? (
                            <StatusChip status="success" className="text-xs">🖼️ Images actives</StatusChip>
                          ) : (
                            <StatusChip status="warning" className="text-xs">⚠️ Images non actives</StatusChip>
                          )}
                          {/* P0 NEW: Badge "Expire bientôt" si needs_refresh */}
                          {xDebugStatus?.needs_refresh && (
                            <StatusChip status="warning" className="text-xs">⚠️ Token expire bientôt</StatusChip>
                          )}
                        </div>
                      ) : xConnectionState === X_STATUS.CONNECTE_NON_VERIFIE ? (
                        <div className="flex flex-col items-end gap-1">
                          <StatusChip status="info">🔄 Non vérifié</StatusChip>
                          {/* P1 FIX: Use mediaUploadCapable from backend */}
                          {mediaUploadCapable ? (
                            <StatusChip status="success" className="text-xs">🖼️ Images actives</StatusChip>
                          ) : (
                            <StatusChip status="warning" className="text-xs">⚠️ Images non actives</StatusChip>
                          )}
                        </div>
                      ) : (
                        // P0 FIX: Show separated status when OAuth2 not connected
                        <div className="flex flex-col items-end gap-1">
                          <StatusChip status="neutral">📝 Non connecté</StatusChip>
                          {/* P1 FIX: Show media capability even if main connection not done */}
                          {mediaUploadCapable && (
                            <StatusChip status="success" className="text-xs">🖼️ Images actives</StatusChip>
                          )}
                        </div>
                      )
                    ) : status === 'connected' ? (
                      <StatusChip status="success">Connecté</StatusChip>
                    ) : status === 'error' ? (
                      <StatusChip status="warning">À vérifier</StatusChip>
                    ) : (
                      <StatusChip status="neutral">Non connecté</StatusChip>
                    )}
                    
                    {/* Actions */}
                    <div className="flex gap-2">
                      {/* Special handling for WhatsApp - manual mode */}
                      {isManual ? (
                        <>
                          <PillButton 
                            variant={status === 'connected' ? 'secondary' : 'primary'} 
                            size="sm"
                            onClick={() => handleToggleManualPlatform(platform.id)}
                            loading={connectingPlatform === platform.id}
                            icon={status === 'connected' ? <CheckCircle className="w-4 h-4 text-green-500" /> : <Plus className="w-4 h-4" />}
                            data-testid={`toggle-${platform.id}`}
                          >
                            {status === 'connected' ? 'Activé' : 'Activer'}
                          </PillButton>
                          {/* Button to show how it works */}
                          <PillButton 
                            variant="ghost" 
                            size="sm"
                            onClick={() => handleConfigureWithAI(platform.id)}
                            title="Voir comment ça marche"
                            data-testid={`howto-${platform.id}`}
                          >
                            <ExternalLink className="w-4 h-4" />
                          </PillButton>
                        </>
                      ) : platform.id === 'x_twitter' ? (
                        // P0 TRUTHFUL: X-specific buttons based on xConnectionState
                        <>
                          {xConnectionState === X_STATUS.EN_COURS ? (
                            <PillButton variant="secondary" size="sm" disabled>
                              <Loader2 className="w-4 h-4 animate-spin" />
                            </PillButton>
                          ) : xConnectionState === X_STATUS.A_REPARER ? (
                            <>
                              <PillButton 
                                variant="primary" 
                                size="sm"
                                onClick={handleClaimXCredentials}
                                icon={<Wrench className="w-4 h-4" />}
                                className="bg-orange-500 hover:bg-orange-600"
                                data-testid="repair-x-btn"
                              >
                                Réparer
                              </PillButton>
                              <PillButton 
                                variant="secondary" 
                                size="sm"
                                onClick={() => handleConnect(platform.id)}
                                title="Reconnecter"
                                data-testid="reconnect-x-btn"
                              >
                                <RefreshCw className="w-4 h-4" />
                              </PillButton>
                            </>
                          ) : xConnectionState === X_STATUS.CONNECTE_NON_VERIFIE ? (
                            <>
                              <PillButton 
                                variant="primary" 
                                size="sm"
                                onClick={handleVerifyX}
                                icon={<ShieldCheck className="w-4 h-4" />}
                                data-testid="verify-x-btn"
                              >
                                Vérifier
                              </PillButton>
                              <PillButton 
                                variant="secondary" 
                                size="sm"
                                onClick={() => handleConnect(platform.id)}
                                title="Reconnecter"
                              >
                                <RefreshCw className="w-4 h-4" />
                              </PillButton>
                            </>
                          ) : xConnectionState === X_STATUS.CONNECTE_VERIFIE ? (
                            <>
                              <PillButton 
                                variant="secondary" 
                                size="sm"
                                onClick={handleVerifyX}
                                title="Revérifier (30s debounce)"
                                data-testid="reverify-x-btn"
                              >
                                <ShieldCheck className="w-4 h-4" />
                              </PillButton>
                              {/* P0 NEW: Bouton Post de test X */}
                              <PillButton 
                                variant="primary" 
                                size="sm"
                                onClick={handleTestXPost}
                                loading={xTestPosting}
                                title="Publier un tweet de test"
                                data-testid="test-x-post-btn"
                              >
                                {xTestPosting ? (
                                  <Loader2 className="w-4 h-4 animate-spin" />
                                ) : (
                                  <Send className="w-4 h-4" />
                                )}
                                <span className="ml-1">Post de test</span>
                              </PillButton>
                              {/* P1 FIX: Hide "Fallback OAuth 1.0a" button when already connected via OAuth 1.0a */}
                              {/* The button only makes sense when user is connected via OAuth 2.0 but needs OAuth 1.0a for images */}
                              {!isOAuth1Connected && (
                                <PillButton 
                                  variant={hasOAuth1Fallback ? "secondary" : "primary"}
                                  size="sm"
                                  onClick={() => setShowOAuth1FallbackModal(true)}
                                  title={hasOAuth1Fallback ? "OAuth 1.0a configuré - Cliquez pour modifier" : "Activer l'upload d'images via OAuth 1.0a"}
                                  className={hasOAuth1Fallback ? "border-green-500/50" : "bg-orange-500 hover:bg-orange-600"}
                                  data-testid="oauth1-fallback-btn"
                                >
                                  <Key className="w-4 h-4" />
                                  <span className="ml-1">{hasOAuth1Fallback ? "🔑 Images" : "⚠️ Images"}</span>
                                </PillButton>
                              )}
                              <PillButton 
                                variant="secondary" 
                                size="sm"
                                onClick={() => handleDisconnect(platform.id)}
                                loading={disconnectingPlatform === platform.id}
                                className="text-red-500 hover:bg-red-500/10"
                                title="Déconnecter"
                              >
                                <Trash2 className="w-4 h-4" />
                              </PillButton>
                            </>
                          ) : (
                            // NON_CONNECTE - P0 FIX: Show "Connecter {platform}" button
                            <PillButton 
                              variant="primary" 
                              size="sm"
                              onClick={() => handleConnect(platform.id)}
                              loading={isConnecting}
                              icon={<Link2 className="w-4 h-4" />}
                              data-testid={`connect-${platform.id}`}
                            >
                              {platform.id === 'x_twitter' ? 'Connecter X' : `Connecter ${platform.name}`}
                            </PillButton>
                          )}
                        </>
                      ) : status === 'connected' ? (
                      <>
                        {/* Bouton Tester */}
                        <PillButton 
                          variant="secondary" 
                          size="sm"
                          onClick={() => handleTestConnection(platform.id)}
                          loading={testingPlatform === platform.id}
                          title="Tester la connexion"
                        >
                          {testingPlatform === platform.id ? (
                            <Loader2 className="w-4 h-4 animate-spin" />
                          ) : (
                            <Send className="w-4 h-4" />
                          )}
                        </PillButton>
                        {/* Bouton Reconfigurer */}
                        <PillButton 
                          variant="secondary" 
                          size="sm"
                          onClick={() => handleConnect(platform.id)}
                          title="Reconfigurer"
                        >
                          <Settings className="w-4 h-4" />
                        </PillButton>
                        {/* Bouton Déconnecter */}
                        <PillButton 
                          variant="secondary" 
                          size="sm"
                          onClick={() => handleDisconnect(platform.id)}
                          loading={disconnectingPlatform === platform.id}
                          className="text-red-500 hover:bg-red-500/10"
                          title="Déconnecter"
                        >
                          {disconnectingPlatform === platform.id ? (
                            <Loader2 className="w-4 h-4 animate-spin" />
                          ) : (
                            <Trash2 className="w-4 h-4" />
                          )}
                        </PillButton>
                        {/* P0 NEW: Expert Help Button - Also visible when connected */}
                        <PillButton 
                          variant="ghost" 
                          size="sm"
                          onClick={() => openSocialExpert(platform.id)}
                          title="Aide Expert"
                          data-testid={`expert-help-${platform.id}`}
                        >
                          <HelpCircle className="w-4 h-4" />
                        </PillButton>
                      </>
                    ) : (
                      <>
                        <PillButton 
                          variant="primary" 
                          size="sm"
                          onClick={() => handleConnect(platform.id)}
                          loading={isConnecting}
                          icon={<Bot className="w-4 h-4" />}
                          data-testid={`configure-${platform.id}`}
                        >
                          Configurer
                        </PillButton>
                        {status === 'error' && (
                          <PillButton 
                            variant="ghost" 
                            size="sm"
                            onClick={() => handleDiagnose(platform.id)}
                          >
                            Diagnostiquer
                          </PillButton>
                        )}
                        {/* P0 NEW: Expert Help Button */}
                        <PillButton 
                          variant="ghost" 
                          size="sm"
                          onClick={() => openSocialExpert(platform.id)}
                          title="Aide Expert"
                          data-testid={`expert-help-${platform.id}`}
                        >
                          <HelpCircle className="w-4 h-4" />
                        </PillButton>
                      </>
                    )}
                    </div>
                  </div>
                </div>
              </div>
                
              {/* WhatsApp manual mode info banner */}
              {isManual && status === 'connected' && (
                <div 
                  className="px-5 pb-4"
                  style={{ borderTop: '1px solid hsl(var(--color-border-subtle))' }}
                >
                  <p className="text-xs text-semantic-muted pt-3">
                    📋 <strong>Publication manuelle :</strong> Copiez/collez le message pour publier manuellement sur WhatsApp
                  </p>
                </div>
              )}
              
              {/* Advanced Options (collapsed by default) */}
              {showAdvanced[platform.id] && (
                <div 
                  className="px-5 pb-5 pt-0"
                  style={{ borderTop: '1px solid hsl(var(--color-border-subtle))' }}
                >
                  <button
                    onClick={() => toggleAdvanced(platform.id)}
                    className="w-full flex items-center justify-between py-3 text-sm text-semantic-muted"
                  >
                    <span>Options avancées (pour experts)</span>
                    <ChevronDown className={cn(
                      'w-4 h-4 transition-transform',
                      showAdvanced[platform.id] && 'rotate-180'
                    )} />
                  </button>
                  
                  <div className="space-y-3 text-sm">
                    <div>
                      <label className="block text-semantic-muted mb-1">App ID</label>
                      <input
                        type="text"
                        placeholder="Laisser vide pour utiliser les valeurs par défaut"
                        className="w-full px-3 py-2 rounded-lg text-sm input-semantic"
                      />
                    </div>
                    <div>
                      <label className="block text-semantic-muted mb-1">Callback URL</label>
                      <div className="flex items-center gap-2">
                        <input
                          type="text"
                          value={`${window.location.origin}/auth/callback/${platform.id}`}
                          readOnly
                          className="flex-1 px-3 py-2 rounded-lg text-sm input-semantic"
                          style={{ opacity: 0.7 }}
                        />
                        <button 
                          className="p-2 rounded-lg transition-colors"
                          style={{ backgroundColor: 'hsl(var(--color-surface-2))' }}
                        >
                          <ExternalLink className="w-4 h-4 text-semantic-muted" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </GlassCard>
          );
        })}
      </div>
      
      {/* AI Help Banner */}
      <GlassCard 
        className="p-5 mb-8"
        style={{ 
          background: 'linear-gradient(to right, hsl(var(--color-info-bg)), hsl(270 50% 95%))',
          borderColor: 'hsl(var(--color-primary) / 0.3)'
        }}
      >
        <div className="flex items-start gap-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center"
            style={{ backgroundColor: 'hsl(var(--color-primary))' }}
          >
            <Bot className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-semantic mb-1">
              Besoin d&apos;aide pour la configuration ?
            </h3>
            <p className="text-sm text-semantic-2 mb-3">
              L&apos;assistant IA vous guide pas à pas. Collez une erreur ou posez une question.
            </p>
            <PillButton variant="outline" size="sm">
              <Bot className="w-4 h-4" />
              Ouvrir l&apos;assistant
            </PillButton>
          </div>
        </div>
      </GlassCard>
      
      {/* P0 PROD FIX: Debug Panel (only visible when ?debug=1) */}
      {isDebugMode && (
        <GlassCard 
          className="p-5 mb-8"
          style={{ 
            background: 'hsl(var(--color-surface-1))',
            borderColor: 'hsl(var(--color-warning) / 0.5)',
            borderWidth: '2px'
          }}
          data-testid="x-debug-panel"
        >
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-semantic flex items-center gap-2">
              <AlertCircle className="w-5 h-5 text-amber-500" />
              X OAuth Debug Panel
            </h3>
            <PillButton 
              variant="outline" 
              size="sm"
              onClick={loadXDebugInfo}
              loading={loadingDebug}
            >
              <RefreshCw className="w-4 h-4" />
              Rafraîchir
            </PillButton>
          </div>
          
          {xDebugData ? (
            <div className="space-y-4 text-sm">
              {/* Status Overview */}
              {xDebugData.status && (
                <div className="p-3 rounded-lg" style={{ background: 'hsl(var(--color-surface-2))' }}>
                  <div className="text-semantic-muted text-xs mb-2 font-semibold">Status (source of truth)</div>
                  <div className="grid grid-cols-2 gap-2 text-xs">
                    <div>
                      <span className="text-semantic-muted">connected: </span>
                      <span className={xDebugData.status.connected ? 'text-green-500 font-bold' : 'text-red-500'}>
                        {String(xDebugData.status.connected)}
                      </span>
                    </div>
                    <div>
                      <span className="text-semantic-muted">has_tokens: </span>
                      <span className={xDebugData.status.has_tokens ? 'text-green-500 font-bold' : 'text-red-500'}>
                        {String(xDebugData.status.has_tokens)}
                      </span>
                    </div>
                    <div>
                      <span className="text-semantic-muted">token_source: </span>
                      <span className={xDebugData.status.token_source === 'project' ? 'text-green-500' : 'text-amber-500'}>
                        {xDebugData.status.token_source}
                      </span>
                    </div>
                    <div>
                      <span className="text-semantic-muted">claim_possible: </span>
                      <span className={xDebugData.status.claim_possible ? 'text-amber-500' : 'text-semantic-muted'}>
                        {String(xDebugData.status.claim_possible)}
                      </span>
                    </div>
                    <div className="col-span-2">
                      <span className="text-semantic-muted">claim_reason: </span>
                      <span className="text-semantic">{xDebugData.status.claim_reason}</span>
                    </div>
                  </div>
                </div>
              )}
              
              {/* Credential Counts */}
              {xDebugData.credential_counts && (
                <div className="p-3 rounded-lg" style={{ background: 'hsl(var(--color-surface-2))' }}>
                  <div className="text-semantic-muted text-xs mb-2">Credential Counts</div>
                  <div className="grid grid-cols-3 gap-2 text-xs">
                    <div>
                      <span className="text-semantic-muted">project: </span>
                      <span className={xDebugData.credential_counts.project_scoped > 0 ? 'text-green-500 font-bold' : 'text-red-500'}>
                        {xDebugData.credential_counts.project_scoped}
                      </span>
                    </div>
                    <div>
                      <span className="text-semantic-muted">user_only: </span>
                      <span className="text-semantic">{xDebugData.credential_counts.user_only_total}</span>
                    </div>
                    <div>
                      <span className="text-semantic-muted">validated: </span>
                      <span className={xDebugData.credential_counts.user_only_validated > 0 ? 'text-amber-500' : 'text-semantic-muted'}>
                        {xDebugData.credential_counts.user_only_validated}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              
              {/* Last OAuth Attempt */}
              {xDebugData.last_oauth_attempt && Object.keys(xDebugData.last_oauth_attempt).length > 0 && (
                <div className={cn(
                  "p-3 rounded-lg border",
                  xDebugData.last_oauth_attempt.error_code 
                    ? "border-red-500/30" 
                    : "border-green-500/30"
                )} style={{ background: xDebugData.last_oauth_attempt.error_code ? 'hsl(var(--color-error-bg))' : 'hsl(var(--color-success-bg))' }}>
                  <div className={cn(
                    "text-xs font-semibold mb-2",
                    xDebugData.last_oauth_attempt.error_code ? "text-red-500" : "text-green-500"
                  )}>
                    {xDebugData.last_oauth_attempt.error_code ? '⚠️ Dernière tentative OAuth (erreur)' : '✅ Dernière tentative OAuth (succès)'}
                  </div>
                  <div className="text-xs space-y-1">
                    {xDebugData.last_oauth_attempt.at && (
                      <div><span className="text-semantic-muted">Quand: </span>{new Date(xDebugData.last_oauth_attempt.at).toLocaleString()}</div>
                    )}
                    {xDebugData.last_oauth_attempt.error_code && (
                      <div><span className="text-semantic-muted">Code: </span><span className="text-red-400">{xDebugData.last_oauth_attempt.error_code}</span></div>
                    )}
                    {xDebugData.last_oauth_attempt.error_stage && (
                      <div><span className="text-semantic-muted">Stage: </span>{xDebugData.last_oauth_attempt.error_stage}</div>
                    )}
                    {xDebugData.last_oauth_attempt.reason && (
                      <div><span className="text-semantic-muted">Raison: </span>{xDebugData.last_oauth_attempt.reason}</div>
                    )}
                    {xDebugData.last_oauth_attempt.x_error_code && (
                      <div><span className="text-semantic-muted">X Error: </span>{xDebugData.last_oauth_attempt.x_error_code}</div>
                    )}
                    {xDebugData.last_oauth_attempt.rid && (
                      <div><span className="text-semantic-muted">RID: </span><code className="text-xs bg-black/20 px-1 rounded">{xDebugData.last_oauth_attempt.rid}</code></div>
                    )}
                  </div>
                </div>
              )}
              
              {/* Channels Config */}
              <div className="p-3 rounded-lg" style={{ background: 'hsl(var(--color-surface-2))' }}>
                <div className="text-semantic-muted text-xs mb-2">channels_config.x_twitter</div>
                <div className="grid grid-cols-3 gap-2 text-xs">
                  <div>
                    <span className="text-semantic-muted">connected: </span>
                    <span className={xDebugData.channels_config?.connected ? 'text-green-500' : 'text-red-500'}>
                      {String(xDebugData.channels_config?.connected)}
                    </span>
                  </div>
                  <div>
                    <span className="text-semantic-muted">enabled: </span>
                    <span className={xDebugData.channels_config?.enabled ? 'text-green-500' : 'text-red-500'}>
                      {String(xDebugData.channels_config?.enabled)}
                    </span>
                  </div>
                  <div>
                    <span className="text-semantic-muted">username: </span>
                    <span className="text-semantic">{xDebugData.channels_config?.x_username || 'null'}</span>
                  </div>
                </div>
              </div>
              
              {/* Project Doc Signals */}
              {xDebugData.project_doc_signals && (
                <div className="p-3 rounded-lg" style={{ background: 'hsl(var(--color-surface-2))' }}>
                  <div className="text-semantic-muted text-xs mb-2">Project-Scoped Credentials</div>
                  <div className="grid grid-cols-2 gap-2 text-xs">
                    <div>has_access: {xDebugData.project_doc_signals.has_access ? '✅' : '❌'}</div>
                    <div>has_refresh: {xDebugData.project_doc_signals.has_refresh ? '✅' : '❌'}</div>
                    <div>x_username: {xDebugData.project_doc_signals.x_username || 'null'}</div>
                    <div>expires_at: {xDebugData.project_doc_signals.expires_at_present ? '✅' : '❌'}</div>
                  </div>
                </div>
              )}
              
              {/* App Configured */}
              <div className="p-3 rounded-lg" style={{ background: 'hsl(var(--color-surface-2))' }}>
                <div className="text-semantic-muted text-xs mb-1">App Configuration</div>
                <div className={cn(
                  "text-xs font-semibold",
                  xDebugData.app_configured ? "text-green-500" : "text-red-500"
                )}>
                  {xDebugData.app_configured ? '✅ X App configurée (Client ID présent)' : '❌ X App non configurée'}
                </div>
              </div>
              
              {/* Legacy Error (from x_oauth_errors collection) */}
              {xDebugData.last_oauth_error_legacy && (
                <div className="p-3 rounded-lg border border-amber-500/30" style={{ background: 'hsl(var(--color-warning-bg))' }}>
                  <div className="text-amber-500 text-xs font-semibold mb-2">⚠️ Erreur Legacy (collection x_oauth_errors)</div>
                  <div className="text-xs space-y-1">
                    <div><span className="text-semantic-muted">Code: </span>{xDebugData.last_oauth_error_legacy.code}</div>
                    {xDebugData.last_oauth_error_legacy.reason && (
                      <div><span className="text-semantic-muted">Raison: </span>{xDebugData.last_oauth_error_legacy.reason}</div>
                    )}
                    {xDebugData.last_oauth_error_legacy.at && (
                      <div><span className="text-semantic-muted">Quand: </span>{xDebugData.last_oauth_error_legacy.at}</div>
                    )}
                  </div>
                </div>
              )}
              
              {/* Build Marker & Timestamp */}
              <div className="flex justify-between text-xs text-semantic-muted">
                <span>build: {xDebugData.build_marker}</span>
                <span>{xDebugData.diagnostic_timestamp ? new Date(xDebugData.diagnostic_timestamp).toLocaleTimeString() : ''}</span>
              </div>
            </div>
          ) : loadingDebug ? (
            <div className="flex items-center justify-center py-4">
              <Loader2 className="w-6 h-6 animate-spin text-semantic-muted" />
            </div>
          ) : (
            <p className="text-semantic-muted text-sm">Cliquez sur Rafraîchir pour charger les données de debug.</p>
          )}
        </GlassCard>
      )}
      
      {/* Continue Button */}
      {hasAnyConnected && (
        <PillButton
          variant="primary"
          size="lg"
          className="w-full ios-animate-fade-in"
          onClick={handleContinue}
          icon={<ArrowRight className="w-5 h-5" />}
          iconPosition="right"
        >
          Continuer
        </PillButton>
      )}
      
      {!hasAnyConnected && (
        <div className="text-center py-4">
          <p className="text-sm text-semantic-muted">
            <AlertCircle className="w-4 h-4 inline mr-1" />
            Connectez au moins une plateforme pour continuer
          </p>
        </div>
      )}
      
      {/* Skip Button */}
      <div className="text-center mt-4">
        <button
          onClick={() => {
            toast.info('Vous pourrez connecter vos plateformes plus tard');
            handleContinue();
          }}
          className="text-sm text-semantic-muted hover:text-semantic transition-colors underline"
          data-testid="skip-connect-btn"
        >
          Je le ferai plus tard
        </button>
      </div>
      
      {/* P0 UX OVERHAUL: Modal configuration is now centralized in GuidedProjectLayout */}
      
      {/* P0 SOCIAL SETUP EXPERT: Drawer is now managed by GuidedProjectLayout via ame:open-social-expert event */}
    </div>
  );
}

/**
 * Step 2 Page Wrapper
 */
export default function ConnectStep() {
  return (
    <GuidedProjectLayout>
      <ConnectStepContent />
    </GuidedProjectLayout>
  );
}
